// removed by extract-text-webpack-plugin
module.exports = {"grid-figure":"_1y0myau8SVDxnAuqib0AYF","form":"_3BrbeURiVYPRrPxj8bRjno","error":"_3X1HSUpY-fWxt-Zy51AINh","control-buttons":"_2NKXWhPfeycbx9YtrPEJDi"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/SignUpLoginForm.styl
// module id = 484
// module chunks = 0